import React from 'react';
import styled from 'styled-components';

const StyledSmartLink = ({ to, children }) => {
  return (
    <StyledAnchor href={to} target="_blank" rel="noopener noreferrer">
      <>{children}</>
    </StyledAnchor>
  );
};

export default StyledSmartLink;

export const StyledAnchor = styled.a`
  color: ${p => p.theme.colors.primaryText};
`;
